import React from 'react';

export interface AboutProps {}

export const About: React.FC<AboutProps> = () => {
    return <img alt="Viljar" src="/images/MacViljar-SG.png" />;
};